import { LoggingDao } from './../daos/logging.dao';
import { IAppConfig } from './../../store';
import { IRecords } from './../interfaces';

import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { Ng2DeviceService } from 'ng2-device-detector';
import { CookieService } from 'ngx-cookie-service';
import { SimpleTimer } from 'ng2-simple-timer';
import { getRegionfromCountryCode, getAkamaiCookie } from '../../common/common';
import {WindowRef} from '../../common';

@Injectable()
export class LogService {
  private _appConfig: IAppConfig;
  private _records: IRecords;
  private _thresholdCounter = 0;

  constructor(
    private deviceService: Ng2DeviceService,
    private dao: LoggingDao,
    private timer: SimpleTimer,
    private cookieService: CookieService,
    private _window: WindowRef
  ) {
    _window.nativeWindow.onbeforeunload = () => {
      if (this._records && this._records.records[0].value.logEntries.length > 0) {
        this.save(this._records, this._appConfig);
      }
    }
  }

  start(appConfig: IAppConfig, loggingState = 'anonymous') {
    // START TIMER
    this.timer.newTimer('log-timer', appConfig.log.thresholdTime);
    this.timer.subscribe('log-timer', () => {
      if (this._records.records[0].value.logEntries.length > 0 && this._thresholdCounter > 0) {
        this.save(this._records, appConfig);
      }
      this._thresholdCounter++;
    });
    this._appConfig = appConfig;
    const akamaiCookie = getAkamaiCookie(this.cookieService);
    const akamaiRegion = getRegionfromCountryCode(akamaiCookie.countryCode);
    this._records = {
      records: [
        {
          value: {
            appName: this._appConfig.appName,
            baseUrl: this._appConfig.baseUrl,
            browserName: this.deviceService.browser,
            browserVersion: this.deviceService.browser_version,
            clientIP: akamaiCookie.clientIP,
            country: akamaiCookie.countryCode,
            deviceType: '',
            guid: UUID.UUID(),
            latitude: akamaiCookie.latitude,
            longitude: akamaiCookie.longitude,
            region: akamaiRegion.akamaiRegion,
            signInState: loggingState,
            subRegion: akamaiRegion.akamaiSubRegion,
            userAgent: this.deviceService.userAgent,
            userId: '',
            userName: '',
            userPhone: '',
            userEmail: '',
            logEntries: []
          }
        }
      ]
    };
  }

  debug(...args) {
    const [
      message,
      title,
      data = '',
      request = '',
      stackTrace = ''
    ] = args;

    this.log('debug', args);
  }

  error(...args) {
    const [
      message,
      title,
      data = '',
      request = '',
      stackTrace = ''
    ] = args;

    this.log('error', args);
  }

  info(...args) {
    const [
      message,
      title,
      data = '',
      request = '',
      stackTrace = ''
    ] = args;

    this.log('info', args);
  }

  warn(...args) {
    const [
      message,
      title,
      data = '',
      request = '',
      stackTrace = ''
    ] = args;

    this.log('warn', args);
  }

  onClose() {
    this.save(this._records, this._appConfig);
  }

  log(severity, args) {
    let [
      message,
      title,
      data = '',
      request = '',
      stackTrace = ''
    ] = args;

    if (!message || !title) {
      return;
    }

    message = this.sanitize(message);
    title = this.sanitize(title);
    data = this.sanitize(data);
    request = this.sanitize(request);
    stackTrace = this.sanitize(stackTrace);

    if (this.isLoggingToServerAllowed(severity, this._appConfig)) {
      this._records.records[0].value.logEntries.push({
        severity: severity,
        timestamp: Date.now(),
        title: title,
        message: message,
        viewPortSize: '',
        stackTrace: stackTrace,
        infoObject: data,
        request: request
      });

      if (this._records.records[0].value.logEntries.length >= this._appConfig.log.thresholdNumber) {
        this.save(this._records, this._appConfig);
      }

    }
  }

  private save(batch: IRecords, appConfig: IAppConfig) {
    if (batch.records[0].value.logEntries.length === 0) {
      return false;
    }
    this.dao.post(batch, appConfig.log.apiKey, 0, 0, 0, appConfig.log.url)
      .subscribe(
        data => batch.records[0].value.logEntries = [],
        error => { batch.records[0].value.logEntries = [] },
        () => { }
      );
  }

  private sanitize(str: string): string {
    if (typeof str === 'object') {
      let tempString = JSON.stringify(str);
      tempString = this.maskButLastFour(tempString);
      str = null;
      return tempString;
    } else {
      return this.maskButLastFour(str);
    }
  }

  private maskButLastFour(str: string): string {
    const pat = /\b(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})\b/;
    str = str.replace(pat, function (match) {
      let strLen, str1, str2;
      strLen = match.length;
      str1 = match.substring(0, strLen - 4);
      str2 = match.substring(strLen - 4);
      str1 = str1.replace(/\d/g, '*');
      return str1 + str2;
    });
    return str;
  }

  private isLoggingToServerAllowed(severity: string, appConfig: IAppConfig): boolean {
    const indexOfAllowed = appConfig.log.logLevels.indexOf(
      appConfig.log.thresholdLevel
    );
    return appConfig.log.logLevels.indexOf(severity) <= indexOfAllowed ? true : false;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/logging.service.ts